import Button from "components/Button/Button";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import Modal from "react-modal";
import GovernanceStore from "stores/GovernanceStore";
import UserStore from "stores/UserStore";
import governanceModalStyles from "./governanceModalStyles";
import GovernanceModal from "./GovernanceModal";
import EthStore from "stores/EthStore";
import { loaderColor } from "../../helpers/constants";
import "./Governance.scss";
import RouterStore from "stores/RouterStore";

Modal.setAppElement("#root");

function Governance() {
  const [showModal, setShowModal] = useState(false);
  const userGovernanceData = GovernanceStore.userData.get(EthStore.account);
  const { weightedNumber, totalYGY } = GovernanceStore;
  const { currentRegeneratorTax } = RouterStore;
  const YGYBalance = UserStore.balances.get("YGY");
  const { contract } = GovernanceStore;
  useEffect(() => {
    if (contract) {
      GovernanceStore.initialize();
    }
  }, [contract]);

  const allowances = UserStore.allowances.get("Governance");
  if (!allowances) return <Loader type="ThreeDots" color={loaderColor} />;
  const allowance = allowances.find((allowance) => allowance.tokenName === "YGY");
  const hasAllowance = allowance && allowance.hasAllowance;

  return (
    <div className="item governance">
      <div className="item-header header-governance">Governance</div>
      <div className="item-content">
        <div className="section-governance">
          <div className="section-title section-title-governance">LP Funding rate - now: {currentRegeneratorTax}%</div>
          <div className="section-item section-governance-description">
            <div className="governance-description-title">What?</div>
            <div className="governance-description-content">
              <p>You can govern the funding rate of liquidity providing by depositing YGY-tokens in the governance contract.</p>
              The result of governance is a single weighted number between <b>1-8</b> that determines the % of LGE deposits that are seized
              and sent to the regenerator for refunding.
              <p>
                Every <b>24</b> hours anyone can click start the update process.
              </p>{" "}
              <p>It's a 2-step flow:</p>
              - First, update regenerator to update stage. <br />
              <br />- After a 10 minute wait anyone can click the update funding rate button to update the current number.
            </div>
          </div>
        </div>
      </div>
      <div className="item-content flex-row">
        <div className="section-item section-current-proposal">
          current global proposal <span className="weighted-number"> {weightedNumber}%</span>
        </div>
        <div className="section-item section-current-proposal">
          total YGY weight <span className="weighted-number"> {totalYGY}</span>
        </div>
      </div>
      <div className="item-content">
        <div className="section-governance">
          {hasAllowance ? (
            <Button type="positive" className="governance-button" onClick={() => setShowModal(true)}>
              Participate
            </Button>
          ) : (
            <Button type="positive" className="governance-button" onClick={() => UserStore.getAllowance("YGY", "Governance")}>
              Approve YGY to participate.
            </Button>
          )}
        </div>
      </div>
      <Modal isOpen={showModal} onRequestClose={() => setShowModal(false)} contentLabel="Pool Info" style={governanceModalStyles}>
        <GovernanceModal userGovernanceData={userGovernanceData} YGYBalance={YGYBalance} />
      </Modal>
    </div>
  );
}

export default observer(Governance);
